"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerFlowType = exports.Association = exports.InventoryServiceType = exports.DeliveryMethod = exports.RogueReasons = exports.PreparationStatus = exports.PaymentMethods = exports.PickupDropoffOption = exports.StatusChangedType = exports.TaskAutomaticallyCancelled = exports.TaskSubType = exports.TaskTypeId = exports.ScanningRole = exports.InventoryChangeType = exports.TaskStatus = exports.OwnerInventoryType = exports.AddressType = exports.TaskHistoryOrigin = exports.TaskCustomAttributesChangeOrigin = exports.TaskHistoryEvent = exports.CarrierSelectorType = exports.NoteType = void 0;
var NoteType;
(function (NoteType) {
    NoteType["FormattedTaskNote"] = "FormattedTaskNote";
    NoteType["Form"] = "Form";
    NoteType["TaskNote"] = "TaskNote";
    NoteType["TaskPhoto"] = "TaskPhoto";
    NoteType["TipSignature"] = "TipSignature";
    NoteType["HtmlTaskNote"] = "HtmlTaskNote";
    NoteType["Signature"] = "Signature";
    NoteType["Document"] = "Document";
})(NoteType || (exports.NoteType = NoteType = {}));
var CarrierSelectorType;
(function (CarrierSelectorType) {
    CarrierSelectorType[CarrierSelectorType["delivery_terms_processing"] = 0] = "delivery_terms_processing";
    CarrierSelectorType[CarrierSelectorType["fleet_rule_usage"] = 1] = "fleet_rule_usage";
    CarrierSelectorType[CarrierSelectorType["quotes_to_external_fleet"] = 2] = "quotes_to_external_fleet";
    CarrierSelectorType[CarrierSelectorType["quote_payload"] = 3] = "quote_payload";
    CarrierSelectorType[CarrierSelectorType["quote_fleet_response"] = 4] = "quote_fleet_response";
    CarrierSelectorType[CarrierSelectorType["fleet_router_run_fail"] = 5] = "fleet_router_run_fail";
})(CarrierSelectorType || (exports.CarrierSelectorType = CarrierSelectorType = {}));
var TaskHistoryEvent;
(function (TaskHistoryEvent) {
    TaskHistoryEvent[TaskHistoryEvent["status_changed"] = 0] = "status_changed";
    TaskHistoryEvent[TaskHistoryEvent["application_event"] = 1] = "application_event";
    TaskHistoryEvent[TaskHistoryEvent["postpone_notification_event"] = 2] = "postpone_notification_event";
    TaskHistoryEvent[TaskHistoryEvent["late_notification_event"] = 3] = "late_notification_event";
    TaskHistoryEvent[TaskHistoryEvent["reassigned"] = 4] = "reassigned";
    TaskHistoryEvent[TaskHistoryEvent["shared_location_sent"] = 5] = "shared_location_sent";
    TaskHistoryEvent[TaskHistoryEvent["client_alert"] = 6] = "client_alert";
    TaskHistoryEvent[TaskHistoryEvent["estimations_updated"] = 7] = "estimations_updated";
    TaskHistoryEvent[TaskHistoryEvent["marked_as_done"] = 8] = "marked_as_done";
    TaskHistoryEvent[TaskHistoryEvent["activity_change"] = 9] = "activity_change";
    TaskHistoryEvent[TaskHistoryEvent["administrator_notification"] = 10] = "administrator_notification";
    TaskHistoryEvent[TaskHistoryEvent["user_rated"] = 11] = "user_rated";
    TaskHistoryEvent[TaskHistoryEvent["shared_location_cancelled"] = 12] = "shared_location_cancelled";
    TaskHistoryEvent[TaskHistoryEvent["customer_alert"] = 13] = "customer_alert";
    TaskHistoryEvent[TaskHistoryEvent["reject_event"] = 14] = "reject_event";
    TaskHistoryEvent[TaskHistoryEvent["dismiss_task"] = 15] = "dismiss_task";
    TaskHistoryEvent[TaskHistoryEvent["payment_event"] = 16] = "payment_event";
    TaskHistoryEvent[TaskHistoryEvent["customer_added_note"] = 17] = "customer_added_note";
    TaskHistoryEvent[TaskHistoryEvent["driver_turned_off_gps"] = 18] = "driver_turned_off_gps";
    TaskHistoryEvent[TaskHistoryEvent["driver_gps_back"] = 19] = "driver_gps_back";
    TaskHistoryEvent[TaskHistoryEvent["client_sent_tip"] = 20] = "client_sent_tip";
    TaskHistoryEvent[TaskHistoryEvent["driver_lost_gps_reception"] = 21] = "driver_lost_gps_reception";
    TaskHistoryEvent[TaskHistoryEvent["driver_found_gps_reception"] = 22] = "driver_found_gps_reception";
    TaskHistoryEvent[TaskHistoryEvent["auto_dispatch_no_drivers_found"] = 23] = "auto_dispatch_no_drivers_found";
    TaskHistoryEvent[TaskHistoryEvent["task_started_event"] = 24] = "task_started_event";
    TaskHistoryEvent[TaskHistoryEvent["task_cancelled_Event"] = 25] = "task_cancelled_Event";
    TaskHistoryEvent[TaskHistoryEvent["webhooks_event"] = 26] = "webhooks_event";
    TaskHistoryEvent[TaskHistoryEvent["checkin_out_of_geofence"] = 27] = "checkin_out_of_geofence";
    TaskHistoryEvent[TaskHistoryEvent["shared_location_sent_via_push"] = 28] = "shared_location_sent_via_push";
    TaskHistoryEvent[TaskHistoryEvent["customer_called_driver"] = 29] = "customer_called_driver";
    TaskHistoryEvent[TaskHistoryEvent["driver_called_customer"] = 30] = "driver_called_customer";
    TaskHistoryEvent[TaskHistoryEvent["customer_smsed_driver"] = 31] = "customer_smsed_driver";
    TaskHistoryEvent[TaskHistoryEvent["driver_smsed_customer"] = 32] = "driver_smsed_customer";
    TaskHistoryEvent[TaskHistoryEvent["eta_updated"] = 33] = "eta_updated";
    TaskHistoryEvent[TaskHistoryEvent["task_forward_declined"] = 34] = "task_forward_declined";
    TaskHistoryEvent[TaskHistoryEvent["task_forward_accepted"] = 35] = "task_forward_accepted";
    TaskHistoryEvent[TaskHistoryEvent["task_rescheduled"] = 36] = "task_rescheduled";
    TaskHistoryEvent[TaskHistoryEvent["distance_traveled_updated_manually"] = 37] = "distance_traveled_updated_manually";
    TaskHistoryEvent[TaskHistoryEvent["geocode"] = 38] = "geocode";
    TaskHistoryEvent[TaskHistoryEvent["task_assigned_to_team"] = 39] = "task_assigned_to_team";
    TaskHistoryEvent[TaskHistoryEvent["notnow_task"] = 40] = "notnow_task";
    TaskHistoryEvent[TaskHistoryEvent["preparation_status_changed"] = 41] = "preparation_status_changed";
    TaskHistoryEvent[TaskHistoryEvent["task_broadcasted"] = 42] = "task_broadcasted";
    TaskHistoryEvent[TaskHistoryEvent["route_optimized"] = 43] = "route_optimized";
    TaskHistoryEvent[TaskHistoryEvent["external_fleet_changed"] = 44] = "external_fleet_changed";
    TaskHistoryEvent[TaskHistoryEvent["external_delivery_changed"] = 45] = "external_delivery_changed";
    TaskHistoryEvent[TaskHistoryEvent["reschedule_virtual_task"] = 46] = "reschedule_virtual_task";
    TaskHistoryEvent[TaskHistoryEvent["task_schedule_ready_time_window_updated"] = 47] = "task_schedule_ready_time_window_updated";
    TaskHistoryEvent[TaskHistoryEvent["task_ready_to_execute_changed"] = 48] = "task_ready_to_execute_changed";
    TaskHistoryEvent[TaskHistoryEvent["way_point_sla_changed"] = 49] = "way_point_sla_changed";
    TaskHistoryEvent[TaskHistoryEvent["way_point_time_window_changed"] = 50] = "way_point_time_window_changed";
    TaskHistoryEvent[TaskHistoryEvent["custom_attribute_changed"] = 51] = "custom_attribute_changed";
    TaskHistoryEvent[TaskHistoryEvent["carrier_selector"] = 52] = "carrier_selector";
})(TaskHistoryEvent || (exports.TaskHistoryEvent = TaskHistoryEvent = {}));
var TaskCustomAttributesChangeOrigin;
(function (TaskCustomAttributesChangeOrigin) {
    TaskCustomAttributesChangeOrigin["ORDER_UPDATE_API"] = "order_update_api";
    TaskCustomAttributesChangeOrigin["AUTOMATION_PLATFORM"] = "automation_platform";
})(TaskCustomAttributesChangeOrigin || (exports.TaskCustomAttributesChangeOrigin = TaskCustomAttributesChangeOrigin = {}));
var TaskHistoryOrigin;
(function (TaskHistoryOrigin) {
    TaskHistoryOrigin[TaskHistoryOrigin["UNKNOWN"] = 0] = "UNKNOWN";
    TaskHistoryOrigin[TaskHistoryOrigin["ROUTE_OPTIMIZATION"] = 1] = "ROUTE_OPTIMIZATION";
    TaskHistoryOrigin[TaskHistoryOrigin["AUTO_DISPATCH"] = 2] = "AUTO_DISPATCH";
    TaskHistoryOrigin[TaskHistoryOrigin["BROADCAST"] = 3] = "BROADCAST";
    TaskHistoryOrigin[TaskHistoryOrigin["MANUAL"] = 4] = "MANUAL";
    TaskHistoryOrigin[TaskHistoryOrigin["REJECT"] = 5] = "REJECT";
    TaskHistoryOrigin[TaskHistoryOrigin["AUTO_REJECT"] = 6] = "AUTO_REJECT";
    TaskHistoryOrigin[TaskHistoryOrigin["USER_ACCEPTED"] = 7] = "USER_ACCEPTED";
    TaskHistoryOrigin[TaskHistoryOrigin["FLEET"] = 8] = "FLEET";
})(TaskHistoryOrigin || (exports.TaskHistoryOrigin = TaskHistoryOrigin = {}));
var AddressType;
(function (AddressType) {
    AddressType[AddressType["Commercial"] = 1] = "Commercial";
    AddressType[AddressType["Residential"] = 2] = "Residential";
    AddressType[AddressType["Educational"] = 3] = "Educational";
    AddressType[AddressType["Government"] = 4] = "Government";
    AddressType[AddressType["Medical"] = 5] = "Medical";
    AddressType[AddressType["Industrial"] = 6] = "Industrial";
})(AddressType || (exports.AddressType = AddressType = {}));
var OwnerInventoryType;
(function (OwnerInventoryType) {
    OwnerInventoryType["Customer"] = "CustomerInventory";
    OwnerInventoryType["User"] = "UserInventory";
})(OwnerInventoryType || (exports.OwnerInventoryType = OwnerInventoryType = {}));
var TaskStatus;
(function (TaskStatus) {
    TaskStatus[TaskStatus["Created"] = 0] = "Created";
    TaskStatus[TaskStatus["Assigned"] = 1] = "Assigned";
    TaskStatus[TaskStatus["OnTheWay"] = 2] = "OnTheWay";
    TaskStatus[TaskStatus["CheckedIn"] = 3] = "CheckedIn";
    TaskStatus[TaskStatus["Done"] = 4] = "Done";
    TaskStatus[TaskStatus["Late"] = 5] = "Late";
    TaskStatus[TaskStatus["Accepted"] = 6] = "Accepted";
    TaskStatus[TaskStatus["Cancelled"] = 7] = "Cancelled";
    TaskStatus[TaskStatus["Rejected"] = 8] = "Rejected";
    TaskStatus[TaskStatus["Unacknowledged"] = 9] = "Unacknowledged";
    TaskStatus[TaskStatus["Pending"] = 10] = "Pending";
})(TaskStatus || (exports.TaskStatus = TaskStatus = {}));
var InventoryChangeType;
(function (InventoryChangeType) {
    InventoryChangeType[InventoryChangeType["Quantity"] = 0] = "Quantity";
    InventoryChangeType[InventoryChangeType["OriginalQuantity"] = 1] = "OriginalQuantity";
    InventoryChangeType[InventoryChangeType["RejectedQuantity"] = 2] = "RejectedQuantity";
})(InventoryChangeType || (exports.InventoryChangeType = InventoryChangeType = {}));
var ScanningRole;
(function (ScanningRole) {
    ScanningRole[ScanningRole["DRIVER"] = 0] = "DRIVER";
    ScanningRole[ScanningRole["DISPATCHER_STAGING"] = 1] = "DISPATCHER_STAGING";
    ScanningRole[ScanningRole["DISPATCHER_COC"] = 2] = "DISPATCHER_COC";
})(ScanningRole || (exports.ScanningRole = ScanningRole = {}));
var TaskTypeId;
(function (TaskTypeId) {
    TaskTypeId[TaskTypeId["PICKUP"] = 2] = "PICKUP";
    TaskTypeId[TaskTypeId["RETURN_TASK"] = 3] = "RETURN_TASK";
    TaskTypeId[TaskTypeId["DELIVERY"] = 4] = "DELIVERY";
    TaskTypeId[TaskTypeId["PICKUP_AND_DELIVERY"] = 5] = "PICKUP_AND_DELIVERY";
    TaskTypeId[TaskTypeId["CLICK_AND_COLLECT"] = 6] = "CLICK_AND_COLLECT";
    TaskTypeId[TaskTypeId["SERVICE"] = 7] = "SERVICE";
    TaskTypeId[TaskTypeId["ROAMING"] = 8] = "ROAMING";
})(TaskTypeId || (exports.TaskTypeId = TaskTypeId = {}));
var TaskSubType;
(function (TaskSubType) {
    TaskSubType[TaskSubType["BACK_TO_WAREHOUSE"] = 1] = "BACK_TO_WAREHOUSE";
})(TaskSubType || (exports.TaskSubType = TaskSubType = {}));
var TaskAutomaticallyCancelled;
(function (TaskAutomaticallyCancelled) {
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["MANUAL"] = 0] = "MANUAL";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["AUTOMATIC"] = 1] = "AUTOMATIC";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["FROM_APPLICATION"] = 2] = "FROM_APPLICATION";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["FROM_LINKED_TASK"] = 3] = "FROM_LINKED_TASK";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["FROM_API"] = 4] = "FROM_API";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["FROM_FLEET"] = 5] = "FROM_FLEET";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["AUTOMATIC_FROM_FLEET"] = 6] = "AUTOMATIC_FROM_FLEET";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["FROM_CHILD_TASK"] = 7] = "FROM_CHILD_TASK";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["FROM_STORE_APP"] = 8] = "FROM_STORE_APP";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["FROM_CUSTOMER_APP"] = 9] = "FROM_CUSTOMER_APP";
    TaskAutomaticallyCancelled[TaskAutomaticallyCancelled["FROM_AUTOMATION_PLATFORM"] = 10] = "FROM_AUTOMATION_PLATFORM";
})(TaskAutomaticallyCancelled || (exports.TaskAutomaticallyCancelled = TaskAutomaticallyCancelled = {}));
var StatusChangedType;
(function (StatusChangedType) {
    StatusChangedType[StatusChangedType["Manual"] = 0] = "Manual";
    StatusChangedType[StatusChangedType["Automatic"] = 1] = "Automatic";
    StatusChangedType[StatusChangedType["Suggested"] = 2] = "Suggested";
    StatusChangedType[StatusChangedType["AutoCorrectedByClient"] = 4] = "AutoCorrectedByClient";
    StatusChangedType[StatusChangedType["AutoCorrectedByServer"] = 5] = "AutoCorrectedByServer";
    StatusChangedType[StatusChangedType["AutomatedByActivityTrigger"] = 6] = "AutomatedByActivityTrigger";
    StatusChangedType[StatusChangedType["FromDashboard"] = 7] = "FromDashboard";
    StatusChangedType[StatusChangedType["FromApplication"] = 8] = "FromApplication";
    StatusChangedType[StatusChangedType["FromRunEnv"] = 9] = "FromRunEnv";
    StatusChangedType[StatusChangedType["AutomaticByServer"] = 10] = "AutomaticByServer";
    StatusChangedType[StatusChangedType["FromApi"] = 11] = "FromApi";
    StatusChangedType[StatusChangedType["AutomaticFromFleet"] = 12] = "AutomaticFromFleet";
})(StatusChangedType || (exports.StatusChangedType = StatusChangedType = {}));
var PickupDropoffOption;
(function (PickupDropoffOption) {
    PickupDropoffOption[PickupDropoffOption["PICKUP"] = 0] = "PICKUP";
    PickupDropoffOption[PickupDropoffOption["DROPOFF"] = 1] = "DROPOFF";
    PickupDropoffOption[PickupDropoffOption["BOTH"] = 2] = "BOTH";
})(PickupDropoffOption || (exports.PickupDropoffOption = PickupDropoffOption = {}));
var PaymentMethods;
(function (PaymentMethods) {
    PaymentMethods[PaymentMethods["UNKNOWN"] = 0] = "UNKNOWN";
    PaymentMethods[PaymentMethods["CASH"] = 1] = "CASH";
    PaymentMethods[PaymentMethods["CREDIT"] = 2] = "CREDIT";
    PaymentMethods[PaymentMethods["CHEQUE"] = 3] = "CHEQUE";
    PaymentMethods[PaymentMethods["CREDIT_CARD_TERMINAL"] = 4] = "CREDIT_CARD_TERMINAL";
})(PaymentMethods || (exports.PaymentMethods = PaymentMethods = {}));
var PreparationStatus;
(function (PreparationStatus) {
    PreparationStatus[PreparationStatus["ACKNOWLEDGED"] = 0] = "ACKNOWLEDGED";
    PreparationStatus[PreparationStatus["START_PREPARATION"] = 1] = "START_PREPARATION";
    PreparationStatus[PreparationStatus["PREPARATION_STARTED"] = 2] = "PREPARATION_STARTED";
    PreparationStatus[PreparationStatus["READY_FOR_PICKUP"] = 3] = "READY_FOR_PICKUP";
    PreparationStatus[PreparationStatus["PICKED_UP"] = 4] = "PICKED_UP";
    PreparationStatus[PreparationStatus["SEND_TO_PREPARATION_FAILED"] = 5] = "SEND_TO_PREPARATION_FAILED";
    PreparationStatus[PreparationStatus["UNACKNOWLEDGED"] = 6] = "UNACKNOWLEDGED";
})(PreparationStatus || (exports.PreparationStatus = PreparationStatus = {}));
var RogueReasons;
(function (RogueReasons) {
    RogueReasons[RogueReasons["TIME_WINDOW"] = 0] = "TIME_WINDOW";
    RogueReasons[RogueReasons["CAPACITY"] = 1] = "CAPACITY";
})(RogueReasons || (exports.RogueReasons = RogueReasons = {}));
var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["Contactless"] = "contactless";
    DeliveryMethod["StreetLevel"] = "street_level";
    DeliveryMethod["AtRoom"] = "at_room";
    DeliveryMethod["ThirdPartyPoint"] = "third_party_point";
    DeliveryMethod["HomeDelivery"] = "home_delivery";
})(DeliveryMethod || (exports.DeliveryMethod = DeliveryMethod = {}));
var InventoryServiceType;
(function (InventoryServiceType) {
    InventoryServiceType["Installation"] = "installation";
    InventoryServiceType["Recycle"] = "recycle";
    InventoryServiceType["Fragile"] = "fragile";
    InventoryServiceType["Heavy_weight"] = "heavy_weight";
    InventoryServiceType["Flammable"] = "flammable";
})(InventoryServiceType || (exports.InventoryServiceType = InventoryServiceType = {}));
var Association;
(function (Association) {
    Association["WayPoint"] = "way_point";
    Association["TaskInventory"] = "task_inventory";
    Association["Form"] = "form";
    Association["TaskNote"] = "task_note";
    Association["TaskPhoto"] = "task_photo";
    Association["Signature"] = "signature";
})(Association || (exports.Association = Association = {}));
var CustomerFlowType;
(function (CustomerFlowType) {
    CustomerFlowType[CustomerFlowType["ClickCollect"] = 0] = "ClickCollect";
    CustomerFlowType[CustomerFlowType["Curbside"] = 1] = "Curbside";
})(CustomerFlowType || (exports.CustomerFlowType = CustomerFlowType = {}));
//# sourceMappingURL=task.js.map